export default __webpack_public_path__ + "static/media/spin-wheel.6674d0ff.svg";